<template>
  <section class="flex flex-col">
    <MainPagePopularArticlesBlock />
    <!--most-discussed-block v-if="!hideDiscussed" /-->
    <slot v-if="$slots.default" name="default"></slot>
  </section>
</template>

<script setup>
// defineProps({
//   hideBooks: {
//     type: Boolean,
//     default: false,
//   },
// });
</script>
